import React, { useEffect, useRef, useState } from 'react';
import { View, Text, Platform } from 'react-native';
import EnterEmailHeader from './component/Header/Header';
import InputText from '@sharedComponents/TextInput/TextInput';
import Button from '@sharedComponents/Button/Button';
import classes from '../../styles/globalClasses';
import gs from '../../styles/globalStyles';
import BottomSheetContainer from '@sharedComponents/Bottomsheet/Bottomsheet';
import { CheckCircle } from '@sharedComponents/Icons';
import VerifyEmailOTP from './component/VerifyEmailOTP/VerifyEmailOTP';
import axios from 'axios';
import { endpoints } from '../../api/apis';
import { showErrorSheet } from '../../store/slices/errorSlice';
import { useAppDispatch , useAppSelector } from '../../store/hooks';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { PrivateStackParamList } from '../../navigationApp/types';
import fetchUserDetails from '../../helper/fetchUserInfo';
import ROUTE from '../../navigationApp/routes';
import Typography from '@sharedComponents/typography/Typography';
import { ColorTokens, TextAlignTokens, TypographyTypeDLS } from '@voltmoney/schema';
import { ThemedView } from '../../theme';
import ScreenWrapper from '@hoc/ScreenWrapper';
import {trackEvent} from '../../utils/amplitude'
import KeyboardDismissView from '@app/hoc/KeyboardDismissView';
import SystemError from '../../../assets/Icons/SystemErrorIcon';
import {X } from '@sharedComponents/Icons'
import { ThemedTouchableOpacity } from '@app/theme/Components';
import { useDarkMode } from '@app/utils';


const emailRegex =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'ENTER_EMAIL'>;

const EnterEmail = ({ navigation  ,route }: ScreenProps) => {
  const userDetails = useAppSelector(state => state.auth.userDetails);
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [isBottomSheetVisible, setIsBottomSheetVisible] = useState(false);
  const ref = useRef(null);
  const dispatch = useAppDispatch();

  const [showResendError, setShowResendError] = useState({isVisible : false , message : ''});
  const isDarkMode = useDarkMode()


  useEffect(() => {
    if (ref.current) {
      ref?.current?.focus();
    }
  }, []);

  const onEmailUpdateSuccess = () => {
    closeBottomSheet();
    setTimeout(() => {
      fetchUserDetails();
      navigation.reset({
        routes: [{ name: ROUTE.HOME }, { name: ROUTE.KYC_PAN_VERIFICATION }],
      });
    }, 1000);
  };
  const closeBottomSheet = () => {
    trackEvent('ENTER_EMAIL_OTP_SHEET_CLOSED') ,{screen : route?.name}
    setIsBottomSheetVisible(false);
  };

  const gotoCheckEligibility = () => {
    navigation.navigate('CheckEligibility');
  };

  const onInput = (text: string) => {
    const updateText = text.trim()
    setEmail(updateText);
    if (!emailRegex.test(updateText)) {
      setIsEmailValid(false);
      setError('Enter a valid email address');
    } else {
      setIsEmailValid(true);
      setError('');
    }
  };


  const showErrorSheetForResend = (err :string) => {
    setShowResendError({isVisible : true , message : err})
  }

  const onContinue = () => {
    setButtonLoader(true);
    ref?.current?.blur()
    const payload = {
      borrowerAccountId: userDetails?.linkedBorrowerAccounts[0]?.accountId,
      emailId: email,
    };
    axios
      .post(endpoints.requestEmailOTP, payload)
      .then(res => {
        setIsBottomSheetVisible(true);
        trackEvent('ENTER_EMAIL_OTP_SHEET_LOADED') ,{screen : route?.name}
      })
      .catch(err => {
        console.log('Enter email err', err);
        dispatch(
          showErrorSheet({
            isErrorSheetVisible : true,
            errorMessage: err?.data?.message,
            closeOnBackdropPress: true,
            errorType: err?.data?.voltErrorCode || err?.data?.statusCode,
            routeName: route?.name
          }),
        );
        console.log('err', err);
      })
      .finally(() => {
        setButtonLoader(false);
      });
  };

  return (
    <ScreenWrapper screenName={route?.name} additionalProperties={{newArchRoute : true}}>
      <KeyboardDismissView>
       <ThemedView flex={1}>
      <EnterEmailHeader pageName={route?.name} navigation={navigation} />
      <ThemedView
       flex={1}
       bg='bg-surface-primary'
       padding='lg'
       >
        <Typography
          typeDLS={TypographyTypeDLS.H3S}
          label={`Enter your email`}
          color={isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night}
        />
        <ThemedView mt="sm" mb="md">
          <Typography
            typeDLS={TypographyTypeDLS.B1R}
            label="We’ll use this to send important updates"
            color={isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal}
          />
        </ThemedView>
        <InputText
          ref={ref}
          keyboardType="email-address"
          label="Email ID"
          showLabel={true}
          showAnimation
          value={email}
          onChangeText={onInput}
          isDarkMode={Boolean(isDarkMode)}
          showErrorMessage={true}
          hasError={error}
          showRightAccessory={true}
          autoFocus={true}
          rightAccessory={() => {
            return (
              <View style={[gs.flexRow, gs.alignItemsCenter]}>
                {isEmailValid && (
                  <CheckCircle
                    size={24}
                    weight="fill"
                    fill="rgb(18, 183, 106)"
                  />
                )}
              </View>
            );
          }}
        />
        <Button
          eventName={'ENTER_EMAIL_CONTIUE'}
          label={'Continue'}
          size="MD"
          handlePress={onContinue}
          type={'SOLID'}
          disabled={!isEmailValid}
          buttonLoader={buttonLoader}
        />
      </ThemedView>
      <BottomSheetContainer
        isVisible={isBottomSheetVisible}
        close={() => {
          closeBottomSheet();
          if(showResendError.isVisible) {
            setTimeout(() => {
              setShowResendError({isVisible : false , message : ''})
              }, 400);
          }
        }}
        closeOnBackdropPress={ showResendError.isVisible ? true :false}
        borderTopRightRadius={10}
        borderTopLeftRadius={10}
        containsTextInput
        containerStyle={{ backgroundColor: '#fefefe' }}
        dragComponent={
          <View
            style={{
              width: 200,
              backgroundColor: 'grey',
              borderRadius: 20,
              height: 4,
              marginVertical: 10,
            }}
          />
        }>
            {showResendError.isVisible ? (
               <View
               style={[
                 gs.alignItemsCenter,
                 gs.justifyCenter,
                 gs.setPadding(16),
               ]}>
               <View style={[gs.setMarginTop(20)]}>
                 <SystemError size={36} />
               </View>
               <ThemedTouchableOpacity onPress={() => {
                closeBottomSheet();
                if(showResendError.isVisible) {
                  setTimeout(() => {
                    setShowResendError({isVisible : false , message : ''})
                    }, 400);
                }
               }} position='absolute' right={20} top={20}>
                <X size={20}/>
               </ThemedTouchableOpacity>
               <View style={{marginTop:16}}>
                    <Typography 
                        typeDLS={TypographyTypeDLS.H4S}
                        color={ColorTokens.Grey_Night}
                        textAlign={TextAlignTokens.center}
                        label={"Verification failed!"}
                    />
                </View>
               <View
                 style={[
                   gs.setMarginTop(16),
                   gs.setColor('#667085'),
                   gs.setMarginBottom(24),
                 ]}>
                  <Typography 
                      typeDLS={TypographyTypeDLS.B1R}
                      color={ isDarkMode? ColorTokens.White :  ColorTokens.Grey_Charcoal}
                      textAlign={TextAlignTokens.center}
                      label={showResendError?.message}
                  />
                </View>
               <Button
                 eventName={'_EDIT'}
                 label={'Edit details'}
                 type={'SOLID'}
                 handlePress={() => {
                  closeBottomSheet()
                  setTimeout(() => {
                  setShowResendError({isVisible : false , message : ''})
                  }, 400);
                 }}
               />
             </View>
            ) : (
              <VerifyEmailOTP
                otpDigitCount={6}
                email={email}
                onClose={closeBottomSheet}
                onEmailUpdateSuccess={onEmailUpdateSuccess}
                userDetails={userDetails}
                onResendFail={showErrorSheetForResend}
              />
            )}
       
      </BottomSheetContainer>
      </ThemedView>
      </KeyboardDismissView>
    </ScreenWrapper>
  );
};

export default EnterEmail;
